import { useState, useEffect, useCallback } from "react";
import { GoldenSourceHelper } from "../../../app/Switch_Core_React_Standards";
import { fetchCorporateEntity } from "../../corporate_details/corporateInteractionService";
import { fetchAddressByOwner } from "../../corporate_details/addressInteractionService";

/**
 * 🎯 Walks Corp.Z_01_CorporateEntity.ParentEntityId upward from companyId to
 * the root, returning [{entity, address}, ...] ordered root-first with the
 * active company last. Used to show "parent -> ... -> this company"
 * wherever a screen works with a specific (possibly child) company.
 */
export default function useCompanyIdentityChain(companyId, siteKey) {
  const [chain, setChain] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = useCallback(async () => {
    if (!companyId) {
      setChain([]);
      return;
    }
    setLoading(true);
    try {
      const nodes = [];
      let currentId = companyId;
      const seen = new Set();
      while (currentId && !seen.has(currentId)) {
        seen.add(currentId);
        const entity = await fetchCorporateEntity(currentId, { siteKey });
        if (!entity) break;
        const guid = GoldenSourceHelper.get(entity, "CorporateEntityGuid");
        const address = guid ? await fetchAddressByOwner(guid, { siteKey }) : null;
        nodes.unshift({ entity, address });
        currentId = GoldenSourceHelper.get(entity, "ParentEntityId") || null;
      }
      setChain(nodes);
    } finally {
      setLoading(false);
    }
  }, [companyId, siteKey]);

  useEffect(() => {
    load();
  }, [load]);

  return { chain, loading };
}
